const ElectrumClient = require('./src/electrum/client')

module.exports = ElectrumClient
